import type { MisconceptionDefinition } from '../types';
export const GET_AFRONDEN: MisconceptionDefinition[] = [{
  id: 'get.afronden-altijd-omlaag',
  label: 'Altijd naar beneden afronden',
  module: 'Getalbegrip',
  description: 'Leerling rondt altijd af op het bestaande cijfer, ook bij honderdsten ≥ 5.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN', 'GET-GROOT-AFRONDEN']
}, {
  id: 'get.afronden-bij-5-omlaag',
  label: 'Bij precies 5 naar beneden afronden',
  module: 'Getalbegrip',
  description: 'Leerling denkt dat 5 of meer naar beneden mag (b.v. 12,345 → 12,34).',
  typicalFamilies: ['GET-KOMMA-AFRONDEN', 'GET-GROOT-AFRONDEN']
}, {
  id: 'get.afronden-aantal-decimalen-verkeerd',
  label: 'Verkeerd aantal decimalen aangehouden',
  module: 'Getalbegrip',
  description: 'Leerling rondt af op een ander aantal decimalen dan gevraagd (b.v. 1 i.p.v. 2 decimalen).',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-onnodige-nul',
  label: 'Onnodige nul of formaatfout',
  module: 'Getalbegrip',
  description: 'Leerling voegt een nul toe of laat de gevraagde decimaal weg (b.v. 12,40 i.p.v. 12,35; of 10 i.p.v. 10,0).',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-doorrol-vergeten',
  label: 'Doorrol bij afronden vergeten',
  module: 'Getalbegrip',
  description: 'Leerling vergeet dat 9,95 doorloopt naar 10,0 en houdt 9,9 of schrijft 9,10.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-volgend-cijfer-meerekenen',
  label: 'Naar verkeerd vervolgcijfer gekeken',
  module: 'Getalbegrip',
  description: 'Leerling kijkt naar het verkeerde cijfer (b.v. duizendsten bij afronden op 1 decimaal).',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-eenmalig-vs-stapsgewijs',
  label: 'Stapsgewijs afronden vs. eenmalig afronden',
  module: 'Getalbegrip',
  description: 'Leerling rondt in één stap af terwijl stapsgewijs gevraagd wordt, of andersom.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-tussenresultaat-als-eind',
  label: 'Tussenresultaat als eindantwoord',
  module: 'Getalbegrip',
  description: 'Leerling stopt na de eerste afrondstap en geeft het tussenresultaat als eindantwoord.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN']
}, {
  id: 'get.schatten-een-factor-afgerond',
  label: 'Slechts één factor afgerond bij schatten',
  module: 'Getalbegrip',
  description: 'Leerling rondt maar één van de twee getallen af bij schatten van een vermenigvuldiging (bv. 48 × 21 → 48 × 20 in plaats van 50 × 20).',
  typicalFamilies: ['GET-GROOT-SCHATTEN']
}, {
  id: 'get.schatten-te-ver-afgerond',
  label: 'Te ver afgerond bij schatten',
  module: 'Getalbegrip',
  description: 'Leerling rondt een getal te ver af naar een minder nauwkeurig veelvoud (bv. 48 → 40 in plaats van 50), waardoor de schatting fors afwijkt.',
  typicalFamilies: ['GET-GROOT-SCHATTEN']
}, {
  id: 'get.schatten-verkeerd-dichtstbijzijnde',
  label: 'Verkeerd dichtstbijzijnde veelvoud gekozen',
  module: 'Getalbegrip',
  description: 'Leerling rondt naar het verkeerde dichtstbijzijnde veelvoud (bv. 21 → 25 i.p.v. 20, of 312 → 350 i.p.v. 300).',
  typicalFamilies: ['GET-GROOT-SCHATTEN']
}, {
  id: 'get.schatten-verkeerde-richting',
  label: 'Verkeerde richting bij afronden binnen schatting',
  module: 'Getalbegrip',
  description: 'Leerling rondt in de verkeerde richting binnen een schatting (bv. 489 → 400 i.p.v. 500 hoewel het tientallencijfer ≥ 5 is).',
  typicalFamilies: ['GET-GROOT-SCHATTEN']
}, {
  id: 'get.schatten-verkeerd-niveau',
  label: 'Afgerond op verkeerd niveau (tientallen i.p.v. honderdtallen)',
  module: 'Getalbegrip',
  description: 'Leerling rondt af op een te fijn niveau (bv. tientallen 310 + 490) waar de opgave vraagt om handige honderdtallen-schatting.',
  typicalFamilies: ['GET-GROOT-SCHATTEN']
}, {
  id: 'get.afronden-richting-fout',
  label: 'Afgerond in verkeerde richting',
  module: 'Getalbegrip',
  description: 'Leerling rondt in de verkeerde richting af (omhoog waar omlaag moest of omgekeerd), ondanks dat het bepalende cijfer correct is afgelezen.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN', 'GET-GROOT-AFRONDEN']
}, {
  id: 'get.afronden-naar-tiental-ipv-honderdtal',
  label: 'Afgerond op tiental i.p.v. honderdtal',
  module: 'Getalbegrip',
  description: 'Leerling rondt af op tientallen terwijl honderdtallen gevraagd werden (of een ander verkeerd niveau).',
  typicalFamilies: ['GET-GROOT-AFRONDEN', 'GET-KOMMA-AFRONDEN']
}, {
  id: 'get.afronden-niet-toegepast',
  label: 'Afronden niet toegepast',
  module: 'Getalbegrip',
  description: 'Leerling laat het getal onveranderd staan en past helemaal geen afronding toe, ondanks de expliciete vraag.',
  typicalFamilies: ['GET-KOMMA-AFRONDEN', 'GET-GROOT-AFRONDEN']
}];